import { AppInjector } from '../utils/services/set-app-injector';
import QueueService from './queue.service';
import { GetRandomInt } from '../utils/services/random-int';
import {
  AccessoryResources,
  AddonsResources,
  AgreementsResource,
  CcdsResources,
  GadgetResources,
  MnpResources,
  MultiSaveResources,
  OtpResources,
  PosResources,
  NewCartResources,
  CheckoutResources,
  NewCustomerResources,
  MsisdnResources,
  RestOrderResource
} from './api-resources.service';

export default class EndpointService {
  private endpoint: any;
  private options: any;
  private id: number;
  private queueLib: QueueService = AppInjector.get(QueueService);

  private multiSaveResources: MultiSaveResources = AppInjector.get(MultiSaveResources);
  private ccdsResources: CcdsResources = AppInjector.get(CcdsResources);
  private mnpResources: MnpResources = AppInjector.get(MnpResources);
  private otpResources: OtpResources = AppInjector.get(OtpResources);
  private accessoryResources: AccessoryResources = AppInjector.get(AccessoryResources);
  private gadgetResources: GadgetResources = AppInjector.get(GadgetResources);
  private addonsResources: AddonsResources = AppInjector.get(AddonsResources);
  private msisdnResources: MsisdnResources = AppInjector.get(MsisdnResources);
  private newCustomerResources: NewCustomerResources = AppInjector.get(NewCustomerResources);
  private posResources: PosResources = AppInjector.get(PosResources);
  private agreementsResources: AgreementsResource = AppInjector.get(AgreementsResource);
  private newCart: NewCartResources = AppInjector.get(NewCartResources);
  private checkout: CheckoutResources = AppInjector.get(CheckoutResources);
  private restOrder: RestOrderResource = AppInjector.get(RestOrderResource);

  private allResources: any = {
    save: this.multiSaveResources,
    ccds: this.ccdsResources,
    mnp: this.mnpResources,
    otp: this.otpResources,
    accessory: this.accessoryResources,
    gadget: this.gadgetResources,
    addons: this.addonsResources,
    msisdn: this.msisdnResources,
    newCustomer: this.newCustomerResources,
    pos: this.posResources,
    agreements: this.agreementsResources,
    newCart: this.newCart,
    checkout: this.checkout,
    restOrder: this.restOrder
  };

  constructor(endpointName: string, requestData: object = {}) {
    if (endpointName === null) {
      return;
    }

    this.endpoint = this.getEndpoint(endpointName);

    if (this.endpoint === null) {
      return;
    }

    this.id = this.getNewId();

    this.options = {
      queue: false,
      queueName: 'default',
      endpointName,
      requestData
    };
  }

  public requestData(requestData: any = {}): EndpointService {
    this.options.requestData = requestData;

    return this;
  }

  public queue(queueName: string = 'default'): EndpointService {
    this.options.queue = true;
    this.options.queueName = queueName;

    return this;
  }

  public propagation(flag: boolean = true): EndpointService {
    this.options.propagation = flag;

    return this;
  }

  public run(): Promise<any> {
    let requestResolve: any = null;
    let requestReject: any = null;

    const promise = new Promise((_resolve: Function, _reject: Function) => {
      requestResolve = _resolve;
      requestReject = _reject;
    });

    // @ts-ignore
    Promise.resolve().then(() => {
      //QUEUE
      let resolve: any = null;
      let reject: any = null;

      const promise = new Promise((_resolve: Function, _reject: Function) => {
        resolve = _resolve;
        reject = _reject;
      });

      if (this.options && this.options.queue) {
        this.queueLib.add(this.id, resolve, this.options.queueName);
      } else {
        resolve();
      }

      return promise;
    }).then(() => {
      //SEND REQUEST

      let resolve: any = null;
      let reject: any = null;

      const promise = new Promise((_resolve: Function, _reject: Function) => {
        resolve = _resolve;
        reject = _reject;
      });

      const endpointApi = this.endpoint(this.options.requestData);

      endpointApi
        .then((response: any) => {
          requestResolve(response);
        })
        .catch((response: any) => {
          requestReject(response);
        })
        .finally(() => {
          resolve();
        });

      return promise;

    }).then(() => {
      //REMOVE FROM QUEUE

      let resolve: any = null;
      let reject: any = null;

      const promise = new Promise((_resolve: Function, _reject: Function) => {
        resolve = _resolve;
        reject = _reject;
      });

      this.removeFromQueue(resolve);

      return promise;

    }).catch(() => {
      this.removeFromQueue();

      requestReject();
    });

    return promise;
  }

  private getEndpoint(endpointName: string = null): any {
    if (endpointName !== null && typeof endpointName === 'string') {
      try {
        const nameChunks = endpointName.split('.');

        if (this.allResources[nameChunks[0]] && this.allResources[nameChunks[0]][nameChunks[1]]) {

          return async (requestData: any = {}) => {
            return await this.allResources[nameChunks[0]][nameChunks[1]](requestData).toPromise();
          };
        }
      } catch (error) {
        console.error(error);
      }
    }

    return null;
  }

  private getNewId(): number {
    return new Date().valueOf() + GetRandomInt(10000, 99999);
  }

  private removeFromQueue(promiseResolve: any = null): void {
    if (this.options.queue) {
      this.queueLib.remove(this.id, this.options.queueName);
    }

    if (promiseResolve !== null) {
      promiseResolve();
    }
  }
}


